import { Component, ElementRef, Input, ViewChild } from '@angular/core';

/**
 * Sticky search box meant to be placed as the first child inside a `mat-select`.
 * Owns its own search `term` so each instance filters independently — read it from
 * the template via a reference variable together with the `filterByName` pipe:
 *
 *   <mat-select (openedChange)="ot.clear()">
 *     <app-select-search #ot></app-select-search>
 *     <mat-option *ngFor="let t of options | filterByName: ot.term" [value]="t.id">...</mat-option>
 *   </mat-select>
 */
@Component({
  selector: 'app-select-search',
  templateUrl: './select-search.component.html',
  styleUrls: ['./select-search.component.scss'],
})
export class SelectSearchComponent {
  @Input() placeholder = 'Suchen…';

  @ViewChild('input') input?: ElementRef<HTMLInputElement>;

  term = '';

  clear(): void {
    this.term = '';
    if (this.input) {
      this.input.nativeElement.value = '';
    }
  }
}
